<!--顶部Banner轮播图-->
<template>
  <div
    :class="[
      isFull ? 'full-screen-default' : smallVideo ? 'banner-default small-video' : 'banner-default',
      env.isBankabc ? 'banner-bankabc' : ''
    ]"
  >
    <!-- 如果是农行，需要占位127px -->
    <div v-if="env.isBankabc" class="bankabc"></div>
    <div
      id="banner"
      :class="{ 'hide-background': video && dataCurrent == 0, 'banner-in-vivo': inVivo }"
      :data-current="dataCurrent"
    >
      <!-- banner渐变背景色 -->
      <div class="banner-bg-transition" v-show="!hideBannerBg" :style="newBannerStyle"></div>
      <!--抢购动态，滚动展示,有氛围抢购才展示-->
      <Dynamic />
      <!-- banner 索引 -->
      <div
        aria-hidden="true"
        v-if="images && images.length + (video && video.videoUrl ? 1 : 0) > 1"
        class="banner-index"
        v-statusBarHeight="'marginTop'"
      >
        <span>{{ realIndex + 1 }}/{{ images.length + (video && video.videoUrl ? 1 : 0) }}</span>
      </div>
      <!-- 3D & 直播 按钮 -->
      <div class="live_3d" v-statusBarHeight="'marginTop'" v-if="isShowLive3d">
        <template v-if="isSupportLive">
          <template v-if="commodityLive.recordedFlag">
            <div
              class="live"
              @click="recorded"
              v-track="[
                {
                  act: 'show',
                  params: {
                    cfrom: '081|070|02|077',
                    event_id: '081|070|02|077',
                    sku_id: skuId,
                    video_id: commodityLive.recordRoomId,
                    id: commodityLive.recordSceneId,
                    type: 2
                  }
                },
                {
                  act: 'click',
                  params: {
                    cfrom: '081|070|01|077',
                    event_id: '081|070|01|077',
                    sku_id: skuId,
                    video_id: commodityLive.recordRoomId,
                    id: commodityLive.recordSceneId,
                    type: 2
                  }
                }
              ]"
              tabindex="0"
              aria-label="直播讲解"
            >
              <div class="live-icon">
                <div class="line-move"></div>
                <div class="line-move"></div>
                <div class="line-move"></div>
              </div>
              <div class="live-text"><span aria-hidden="true">直播讲解</span></div>
            </div>
          </template>
          <template v-else-if="commodityLive.liveFlag">
            <div
              class="live"
              @click="live"
              v-track="[
                {
                  act: 'show',
                  params: {
                    cfrom: '081|070|02|077',
                    event_id: '081|070|02|077',
                    sku_id: skuId,
                    video_id: commodityLive.liveRoomId,
                    id: commodityLive.liveSceneId,
                    type: 1
                  }
                },
                {
                  act: 'click',
                  params: {
                    cfrom: '081|070|01|077',
                    event_id: '081|070|01|077',
                    sku_id: skuId,
                    video_id: commodityLive.liveRoomId,
                    id: commodityLive.liveSceneId,
                    type: 1
                  }
                }
              ]"
            >
              <div class="live-icon">
                <div class="line-move"></div>
                <div class="line-move"></div>
                <div class="line-move"></div>
              </div>
              <div class="live-text"><span>直播</span></div>
            </div>
          </template>
          <div class="line" v-if="(commodityLive.recordedFlag || commodityLive.liveFlag) && show3D"></div>
        </template>

        <div
          class="banner-3d"
          v-if="show3D"
          @click="open3D"
          v-track="{ act: 'show', params: trackData.three3DShow({ sku_id: skuId }) }"
        >
          <img class="img" src="./images/3d.png" alt="" />
        </div>
      </div>
      <!--轮播图-->
      <swiper
        v-if="(video && video.videoUrl) || (images && images.length)"
        :class="['banner-swiper', 'banner-swiper--' + discountType]"
        ref="mySwiper"
        :noSwiping="true"
        :options="{
          slidesPerView: images.length > 1 ? 'auto' : 1
        }"
        @slideChange="slideChange"
        @touchStart="touchStart"
        @touchEnd="touchEnd"
        role="list"
      >
        <!--video-->
        <swiper-slide v-if="video && video.videoUrl" role="listitem" tabindex="-1" aria-label="视频">
          <div
            :class="[
              'video-container',
              env.isBankabc ? 'small-bankabc' : '',
              video.hvScreenFlag === 1 ? 'hv-screen' : ''
            ]"
            :style="{ marginTop: smallVideoMT, height: isFull ? offsetHeight + ' !important' : '' }"
            v-track="
              trackData.bannerClick({
                position: 1,
                img_content: 2,
                back_color: backColor,
                sku_id: skuId,
                page_name: pageName
              })
            "
            :data-is-playing="isShowVideo && current === 0"
          >
            <img
              v-lazy="commodityBigPromotion.headImgUrl"
              class="swiper-img-bg"
              v-if="realIndex == 0 && commodityBigPromotion && commodityBigPromotion.headImgUrl"
            />
            <video-player
              v-show="isShowVideo"
              class="video-show"
              ref="videoPlayer"
              :options="playerOptions"
              :playsinline="isShowVideo"
              @ended="onPlayerEnded($event)"
              :events="['fullscreenchange']"
              @fullscreenchange="onPlayerFullscreenChange($event)"
            ></video-player>
            <div
              id="fullscreenMask"
              v-show="isShowVideo && !smallVideo && !isFull"
              class="vjs-mask-app full"
              @click="fullScreen"
            ></div>
            <div
              v-show="isFull"
              class="back-fulll"
              v-statusBarHeight="'marginTop'"
              @click="closeFull"
              v-backFn="{ show: isFull, closeFn: 'closeFull' }"
            >
              <Icon name="arrow-left" />
            </div>
            <keep-alive>
              <div v-if="!isShowVideo && videoReady" class="video-hide item-img">
                <img alt="" v-lazy="video.bigCover" />
                <div
                  tabindex="0"
                  role="button"
                  aria-label="播放视频"
                  id="video-start"
                  class="start"
                  v-if="videoInitFlag"
                  @click="checkEnv"
                  v-observer="observeVideoStart"
                ></div>
              </div>
            </keep-alive>
            <div class="vjs-mask-app" v-show="showMaskApp">
              <p class="tip">您正在使用非Wifi网络，播放将消耗您的流量</p>
              <v-checkbox class="checkbox-4g" :value="true">7天内不再提示</v-checkbox>
              <div class="opts">
                <a href="javascript:;" class="btn J-waiver" @click="closeVideo">不播了</a>
                <a href="javascript:;" class="btn J-confirm" @click="playContinue">继续播放</a>
              </div>
            </div>
          </div>
        </swiper-slide>
        <!--images-->
        <!-- 全屏播放的时候会有滚动兼容性，这里如果是全屏那么就不展示后面的内容 -->
        <template v-if="!isFull">
          <img
            :src="commodityBigPromotion.headImgUrl"
            class="swiper-img-bg"
            v-if="realIndex == 0 && commodityBigPromotion && commodityBigPromotion.headImgUrl"
          />
          <swiper-slide
            v-for="(item, index) in images"
            :key="index"
            tabindex="-1"
            :aria-label="`图片，第${index + 1}张，共${
              images.length + (video && video.videoUrl ? 1 : 0)
            }张,点按两次即可激活`"
          >
            <div class="item-img">
              <img
                class="swiper-lazy small-image"
                alt=""
                v-lazy="item.bigPic"
                src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                :key="item.bigPic"
                @click="showPreview(index)"
                v-track="
                  trackData.bannerClick({
                    position: index + (video ? 2 : 1),
                    img_content: isOnlyCover && index == 0 ? 3 : 1,
                    back_color: backColor,
                    sku_id: skuId,
                    page_name: pageName
                  })
                "
              />
            </div>
          </swiper-slide>
          <SlideMore v-if="hasSecondBar" />
        </template>
      </swiper>

      <!-- 版本外显-颜色 -->
      <SkuColor v-if="showOuterColor" :spuInfo="spuInfo" :show3D="show3D" />
    </div>

    <!-- 视频关闭, banner播放时的关闭按钮 -->
    <!-- 只有新版本，不显示app title的才显示 -->
    <div
      v-if="showClose"
      v-show="isShowVideo && realIndex == 0 && !isFull && !smallVideo"
      v-statusBarHeight="'marginTop'"
      class="close"
      @click="resetBannerState"
      tabindex="0"
      role="button"
      aria-label="关闭视频"
    >
      <Icon name="cross" />
    </div>
    <!-- 视频关闭, 小窗播放关闭按钮 -->
    <div
      v-show="isShowVideo && smallVideo"
      class="close"
      :style="{ marginTop: smallVideoMT }"
      @click="resetBannerState"
      v-track="trackData.smallVideo({ sku_id: skuId, video_content: 2 })"
      tabindex="0"
      role="button"
      aria-label="关闭视频"
    >
      <Icon name="cross" />
    </div>

    <!--大图展示-->
    <v-image-preview
      :show="isShowPreview"
      :images="previewImages"
      :startPosition="current"
      :onClose="onClosePreview"
      :bgStyle="bannerStyle"
      :slideMore="!!hasSecondBar"
      :theme="isDarkColor ? 'black' : 'white'"
      @slideAction="slideAction"
      v-backFn="{ show: isShowPreview, closeFn: 'onClosePreview' }"
      class="image-preview"
    />

    <!-- 单独视频播放 -->
    <CommonPopup
      class="video-page"
      v-if="isShowVideoPage"
      @close="closeVideoPage"
      :menu="false"
      title="视频"
      v-backFn="{ show: isShowVideoPage, closeFn: 'closeVideoPage' }"
    >
      <div class="video-page-wrap">
        <div class="video-content">
          <video id="myVideo" :src="video.videoUrl" preload="auto" muted="false" controls="controls"></video>
        </div>
      </div>
    </CommonPopup>
  </div>
</template>

<script>
import { Icon } from '@vivo/shop-ui-h5'
import SlideMore from '@/components/slide-more'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import SkuColor from '../sku-color'
import { mapState, mapGetters } from 'vuex'
import 'swiper/dist/css/swiper.css'
import 'video.js/dist/video-js.css'
import Dynamic from './compontents/dynamic'
import CommonPopup from '../common-popup'
import { app } from '@/utils'
// 用于设置视频播放7天是否提醒
import { setCookie, getCookie } from 'utils/common'
// 环境判断，QQ、官网App、微信、支付宝、农行app等环境判断
import env from '@/utils/clientEnv'
import trackData from './trackData'

const createLoader = () => {
  let evt = []
  let READY = []
  let state = false
  return {
    createComponent() {
      return new Promise(resolve => {
        if (state === false) {
          evt.push(resolve)
          READY.forEach(fn => fn())
        }
        state = true
      })
    },
    ready(fn) {
      if (state === true) {
        fn()
      }
      READY.push(fn)
    },
    async startLoadComponent() {
      let com = await import('vue-video-player')
      let res = com.videoPlayer
      evt.forEach(async fn => {
        await fn(res)
      })
    }
  }
}
const loader = createLoader()

const postImg = 'https://shopstatic.vivo.com.cn/vivoshop/spawap/static/img/poster.png'
export default {
  name: 'Banner',
  components: {
    Icon,
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide,
    Dynamic,
    SkuColor,
    videoPlayer: async () => {
      const sync = await loader.createComponent()
      return sync
    },
    SlideMore,
    CommonPopup
  },
  props: ['show3D'],
  data() {
    return {
      trackData,
      // 环境信息
      env,
      // 抢购轮播信息
      vbuyDynamic: null,
      // 抢购动态本地轮询事件函数
      vbuyDynamicInterval: undefined,
      isShowVideo: false,
      videoReady: false,
      isShowPreview: false,
      // 是否为小窗播放
      smallVideo: false,
      // 判断竖屏全屏是不是来自于小屏点击
      fullFromSmall: false,
      current: 0,
      dataCurrent: 0,
      // 适配播放时，如果是app环境，且是移动网络，提示用户是否播放
      showMaskApp: false,
      translate: 0,
      limit: -80,
      // 当前swiper索引
      realIndex: 0,
      player: '',
      // 官网App顶部高度
      appHeaderHeight: 0,
      // 浏览器高度，
      offsetHeight: document.body.offsetHeight + 'px',
      // 竖屏全屏
      isFull: false,
      // 7天不提醒
      checked: true,
      // 当前是播放还是暂停状态
      currentPaused: null,
      // cookie名称
      video_seven_day: 'video_seven_day',
      // 是否显示头部
      showClose: !(env.isVivoApp && !env.isDefaultHideTitle) && !env.isVHome,
      // 判断是否在vivo浏览器和官网App中，其他环境中，适配播放都跳转单独页面
      inVivo: (env.isVivoApp && !env.isIOSVivoApp) || env.isVivoBrowser,
      // 是否显示单独的视频页面
      isShowVideoPage: false
    }
  },
  computed: {
    ...mapState('detailv3', ['spuInfo', 'skuInfo', 'isVideoCanPlay', 'videoInitFlag']),
    ...mapGetters('detailv3', [
      'skuId',
      'spuId',
      'discountType',
      // 版本是否外显
      'showOuterVersion',
      'isShowPromotion',
      // 颜色是否外显
      'showOuterColor',
      // 当前套餐信息
      'currentSuiteInfo',
      // 判断是否为套餐，且有套餐图片
      'hasSuiteImages',
      // 渐变色
      'color',
      // 判断深浅色
      'isDarkColor',
      // 图片预览背景色
      'bannerStyle',
      // 直播相关
      'commodityLive',
      'commodityBigPromotion',
      'isAPPTemplate'
    ]),
    newBannerStyle() {
      return {
        backgroundImage: `linear-gradient(to bottom, ${this.color.value} 0%, ${this.color.value} 84.25%, rgba(245, 254, 250, 0.2) 100%)`
      }
    },
    // 只上传了视频封面&&未上传视频
    isOnlyCover() {
      return this.video && !this.video.videoUrl && this.video.hdCover && this.video.bigCover
    },
    // 埋点参数page_name
    pageName() {
      return this.discountType == 'group' ? 2 : 1
    },
    // 商品主图
    images() {
      let temp = []
      if (this.hasSuiteImages) {
        temp = this.currentSuiteInfo?.imageInfos
      } else {
        temp = this.skuInfo?.imageInfos || []
      }
      let info = []
      // 如果只上传了视频封面，则封面和普通图片放在一起轮播,且放在第一张
      if (this.isOnlyCover) {
        info.push({
          bigPic: this.video.bigCover,
          hdPic: this.video.hdCover,
          smallPic: this.video.smallCover
        })
      }
      temp.forEach(item => {
        if (item.bigPic) {
          info.push(item)
        }
      })
      return info
    },
    // 小窗视频位置
    smallVideoMT() {
      return this.smallVideo && this.env.isDefaultHideTitle ? '0.7rem' : ''
    },

    // 视频图片
    video() {
      if (this.hasSuiteImages) {
        return false
      }
      // hvScreenFlag: 横竖屏标识， 0-横屏 1-竖屏
      return this.skuInfo?.videoInfo?.bigCover && this.skuInfo?.videoInfo
    },
    videoUrl() {
      return this.video?.videoUrl
    },

    // 判断是否为渐变， 1:渐变;2:常规
    backColor() {
      if (this.color?.value === '#ffffff' && this.color?.valueExt === '#ffffff') {
        return 2
      }
      return 1
    },
    hideBannerBg() {
      // 团购、秒杀、定金预售、全款预定、会员先享购有固定渐变色，不需要动态渐变
      return ['group', 'quickbuy', 'fullpay', 'deposit', 'vip'].includes(this.discountType)
    },

    /**
     * 适配播放参数
     */
    playerOptions() {
      return {
        muted: true,
        autoplay: false,
        width: document.body.clientWidth,
        height: document.body.clientWidth - 30,
        language: 'en',
        controlBar: true,
        preload: 'none',
        sources: [
          {
            type: 'video/mp4',
            src: this.video && this.video.videoUrl
          }
        ],
        children: ['mediaLoader']
      }
    },

    /**
     * 轮播组件
     */
    swiper() {
      return this.$refs?.mySwiper?.swiper
    },

    /**
     * 大图预览
     */
    previewImages() {
      if (this.images[0]?.hdPic) {
        // 兼容离屏渲染预拉取数据的只有bigPic精简数据结构
        return this.images.map(v => v.hdPic)
      } else {
        return this.images.map(v => v.bigPic)
      }
    },

    // 判断是否存在二级标题
    hasSecondBar() {
      return this.skuInfo?.intro || this.skuInfo?.parameters?.length || this.skuInfo?.boxingImg
    },
    // 3d和直播模块显示
    isShowLive3d() {
      return (this.isSupportLive && (this.commodityLive.recordedFlag || this.commodityLive.liveFlag)) || this.show3D
    },
    // 是否支持live
    isSupportLive() {
      // app版本号6090，拼团，会员优享购，秒杀不展示
      return app.checkVersion(6010) && this.discountType !== 'vip' && this.discountType !== 'group'
    },
    isTemplate() {
      // TODO: 适配离app屏渲染预下载图片，当前版本官网评估性能影响延后
      return this.isAPPTemplate
    }
  },
  mounted() {
    this.$nextTick(this.init)
    // 小窗静音按钮埋点、小窗点击全屏监控
    this.listenerClick()
    // banner首长图片曝光埋点
    this.slideLog()
    // 加载图片
    try {
      let image = new Image()
      image.src = postImg
      image.onload = () => {}
    } catch (e) {}
    window.addEventListener('resize', () => {
      // pad下竖屏切换横屏时，视频播放全屏区域高度刷新
      this.offsetHeight = document.body.offsetHeight + 'px'
    })
  },
  watch: {
    videoUrl(val) {
      if (val) {
        this.setPlayer()
        this.resetBannerState()
      } else {
        this.isShowVideo = false
      }
    },
    isVideoCanPlay(val) {
      if (this.player) {
        // 弹层打开时，关闭视频
        if (this.isShowVideo && this.swiper.realIndex === 0) {
          if (val) {
            this.currentPaused === false && this.player.play()
            this.currentPaused = null
          } else {
            // 记录打开弹层时，是否为暂停状态
            this.currentPaused = this.player.paused()
            this.player.pause()
          }
        }
      }
    },
    // 切换规格时，回到第一页
    images(val) {
      this.$nextTick(() => {
        this.swiper && this.swiper.slideTo(0)
      })
    },
    smallVideo(val) {
      if (val) {
        setTimeout(() => {
          app.setStatusBarColor('black')
        }, 100)
      }
    }
  },
  methods: {
    init() {
      let self = this
      loader.ready(async () => {
        await loader.startLoadComponent()
        self.videoReady = true
        // 设置player
        self.setPlayer()
      })
      this.$nextTick(() => {
        this.observe()
      })
    },
    videoPic() {
      return require(`./images/pic-${this.color.value.slice(1)}.png`)
    },

    /**
     * 监听静音按钮点击事件，用于埋点
     */
    listenerClick() {
      let self = this
      // 全屏埋点事件
      document.querySelector('#banner').addEventListener('touchstart', e => {
        try {
          let className = e.target.offsetParent.className
          // 小窗模式
          if (self.isShowVideo && self.smallVideo) {
            if (className.indexOf('vjs-volume-panel') > -1 || className.indexOf('vjs-mute-control') > -1) {
              self.$track({
                cfrom: '171|002|01|077',
                event_id: '171|002|01|077',
                page_name: 1,
                sku_id: self.skuId,
                video_content: 1
              })
            }
          }
          if (className.indexOf('video-js') > -1) {
            self.fullVideo()
          }
        } catch (e) {}
      })
    },
    onPlayerFullscreenChange(e) {
      let currentTime = this.player.currentTime()
      let remainingTime = this.player.remainingTime()
      // 假设视频播放剩余时间小于3秒且处于播放状态，则将视频回退3秒
      if (remainingTime < 3 && !this.player.paused()) {
        // this.player.pause()
        this.player.currentTime(currentTime - 3)
        // // 这里延迟是因为在切换横竖屏时，会触发两次onPlayerFullscreenChange事件
        // setTimeout(() => {
        //   this.player.play()
        // }, 0)
      }
    },

    /**
     * 小窗播放时，点击适配进入全屏
     */
    fullVideo() {
      if (this.smallVideo && !this.env.isBankabc) {
        this.fullFromSmall = true
        this.smallVideo = false
        this.$nextTick(() => {
          this.fullScreen()
        })
      }
    },

    /**
     * 重置播放状态
     */
    resetBannerState() {
      this.isShowVideo = false
      this.showMaskApp = false
      this.smallVideo = false
      try {
        this.player && this.player.pause()
      } catch (e) {}
    },

    /**
     * 滑动改变显示时执行
     */
    slideChange() {
      let self = this
      // 判断视频是否显示
      this.dataCurrent = self.swiper.realIndex
      if (self.isShowVideo && self.player) {
        if (self.swiper.realIndex === 0) {
          self.player.play()
          app.setStatusBarColor('white')
        } else {
          self.player.pause()
          app.setStatusBarColor('black')
        }
      }
      self.slideLog()
      setTimeout(() => {
        self.realIndex = self.swiper.realIndex
      }, 80)
    },

    /**
     * 滑动时，banner曝光埋点
     */
    slideLog() {
      let self = this
      const isVideo = self.video && self.video.videoUrl && self.swiper.realIndex === 0
      // img_content 1:图片;2:视频;3:视频纯封面
      let imgContent = 1
      if (isVideo) {
        imgContent = 2
      } else if (self.isOnlyCover && self.swiper.realIndex === 0) {
        imgContent = 3
      }
      self.$track(
        self.trackData.bannerShow({
          position: self.swiper.realIndex + 1,
          img_content: imgContent,
          back_color: self.backColor,
          sku_id: self.skuId,
          page_name: self.pageName
        })
      )
    },

    /**
     * 滑动开始事件，记录位置
     */
    touchStart() {
      this.translate = this.swiper.getTranslate()
    },

    /**
     * 滑动结束后执行
     */
    touchEnd() {
      if (this.hasSecondBar) {
        let move = this.swiper.translate - this.translate
        if (this.swiper.isEnd && move < this.limit) {
          this.slideAction()
        }
      }
    },

    /**
     * 滚动到详情
     */
    slideAction() {
      // 查看详情
      this.$emit('toProductDetail')
    },

    /**
     * 设置player
     */
    setPlayer() {
      let self = this
      self.$nextTick(function () {
        self.player = self.$refs?.videoPlayer?.player
      })
    },

    /**
     * 重新设置player，切换sku后$nextTick中取不到player信息
     */
    resetPlayer() {
      this.player = this.$refs?.videoPlayer?.player
    },

    /**
     * 视频结束时触发
     */
    onPlayerEnded(player) {
      try {
        this.isFull && this.closeFull()
      } catch (e) {}
      // 去除小屏播放
      this.smallVideo = false
      this.isShowVideo = false
    },

    /**
     * 检查是不是在官网app和vivo浏览器中
     */
    checkEnv() {
      this.setPoster()
      if (this.inVivo) {
        this.checkApp()
      } else {
        this.isShowVideoPage = true
        this.$nextTick(() => {
          this.playVideo()
        })
      }
    },

    /**
     * 视频封面
     */
    setPoster() {
      // 覆盖视频封面，解决官网app播放视频开始时先显示黑色占位图的问题
      if (document.querySelector('.vjs-tech')) {
        document.querySelector('.vjs-tech').setAttribute('poster', postImg)
      }
    },

    /**
     * 关闭视频页面
     */
    closeVideoPage() {
      this.isShowVideoPage = false
    },

    /**
     * 检查是否在app中，且app版本大于920，判断是否提示播放
     */
    checkApp() {
      let self = this
      let _show = getCookie(self.video_seven_day)
      if (!_show && app.checkVersion(920)) {
        app.isMobileNet(function (isMobile) {
          // 移动网络,显示提示信息
          if (isMobile) {
            self.showMaskApp = true
          } else {
            self.changeToVideo()
          }
        })
      } else {
        this.changeToVideo()
      }
    },

    /**
     * 播放视频
     */
    changeToVideo() {
      this.resetPlayer()
      this.showMaskApp = false
      try {
        // fix:Uncaught (in promise) DOMException: The play() request was interrupted by a call to pause().
        if (this.player) {
          this.player.play()
          // 音量按钮适配无障碍播报
          let controlEl = document.getElementsByClassName('vjs-mute-control')[0]
          if (controlEl) {
            controlEl.setAttribute('aria-label', '音量开关')
            controlEl.setAttribute('title', '')
          }
          this.isShowVideo = true
        }
      } catch (e) {
        console.log('error')
      }
    },

    /**
     * 继续播放
     */
    playContinue() {
      // 当选中7天不再提醒
      if (this.checked) {
        setCookie(this.video_seven_day, 'show', 7)
      }
      this.changeToVideo()
    },

    /**
     * 不播放视频
     */
    closeVideo() {
      this.showMaskApp = false
    },

    /**
     * 关闭大图预览
     */
    onClosePreview() {
      this.isShowPreview = false
    },

    /**
     * 显示大图预览
     */
    showPreview(index) {
      if (
        app.viewImgs({
          browse: {
            images: this.previewImages,
            imageIndex: index
          },
          gradient: {
            fromColor: this.color.value,
            toColor: this.color.valueExt,
            titleColor: this.isDarkColor ? '#ffffff' : '#000000'
          },
          bigImg: {
            // 是否需要滑动查看详情
            useTip: !!this.hasSecondBar
          }
        })
      ) {
        // 查看大图
      } else {
        this.current = index
        this.isShowPreview = true
      }
    },

    /**
     * 点击竖屏全屏，需要给横屏时添加返回按钮
     */
    fullScreen() {
      if (this.env.isBankabc) {
        return
      }
      this.toggleTitleBarNew(false)
      this.isFull = true
      let $div = document.createElement('div')
      $div.innerHTML = `
          <div id="exitFullscreen" class="exit-fullscreen" style="display:none;"></div>
        `
      $div.onclick = this.closeFull
      let $bar = document.getElementsByClassName('vjs-control-bar')[0]
      $bar.appendChild($div)
      setTimeout(() => {
        app.setStatusBarColor('white')
      }, 100)
    },

    /**
     * 取消全屏
     */
    closeFull() {
      this.toggleTitleBarNew(true)
      this.player && this.player.isFullscreen_ && this.player.exitFullscreen && this.player.exitFullscreen()
      this.isFull = false
      if (this.fullFromSmall) {
        this.smallVideo = true
      } else {
        this.swiper && this.swiper.slideTo(0)
      }
      this.fullFromSmall = false
      setTimeout(() => {
        app.setStatusBarColor('white')
      }, 100)
    },

    /**
     * 显示还是隐藏头部
     */
    toggleTitleBarNew(isShow) {
      // 如果是老版本，默认显示头的时候，需要隐藏掉
      if (!env.isDefaultHideTitle) {
        app.toggleTitleBarNew({
          isShow
        })
      }
    },

    /**
     * 当视频播放时，如果离开视口，则转化成小屏播放
     */
    observe() {
      let self = this
      const IO = new IntersectionObserver(entries => {
        if (self.isShowVideo && self.realIndex === 0) {
          entries.forEach(entry => {
            // 元素进入视口
            if (entry.isIntersecting) {
              self.smallVideo = false
            } else {
              // 离开视口
              self.smallVideo = true
            }
          })
        }
      })
      IO.observe(document.getElementById('banner'))
    },

    /**
     * 用于播放
     */
    playVideo() {
      try {
        const video = document.getElementById('myVideo')
        video.play()
      } catch (e) {}
    },
    open3D() {
      this.$emit('open3D')
    },
    observeVideoStart(val) {
      // 只有视频在播放的情况下，才是白色的
      if (!val && this.isShowVideo) {
        app.setStatusBarColor('white')
      } else {
        app.setStatusBarColor('black')
      }
    },
    live() {
      location.href = `space://vivo.com/deeplinkbridge?pageName=pageLivePlayIng&roomId=${this.commodityLive.liveRoomId}&spuId=${this.spuId}&isShopDetailJump=1`
    },
    recorded() {
      location.href = `space://vivo.com/deeplinkbridge?pageName=pageLivePlayBack&roomId=${this.commodityLive.liveRoomId}&sceneId=${this.commodityLive.liveSceneId}&streamUrl=${this.commodityLive.recordVideoUrl}&recordRoomId=${this.commodityLive.recordRoomId}&recordSceneId=${this.commodityLive.recordSceneId}&spuId=${this.spuId}&isShowLiveBtn=${this.commodityLive.liveFlag}&isShopDetailJump=1`
    }
  }
}
</script>

<style lang="scss">
// deeplink 下载样式适配
.vp-header-show-app {
  .banner-default {
    .close {
      top: 213px;
    }
  }

  .small-video {
    #banner {
      .video-container {
        top: 482px !important;
      }
    }
    .close {
      top: 492px !important;
    }
  }
}
</style>

<style lang="scss" scoped src="./index.scss"></style>
